module.exports = __webpack_public_path__ + "static/media/ab_notify_client_sv_yl.ed9eb3f9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ab_notify_client_sv_yl.svg
// module id = 1262
// module chunks = 0